<template>
  <div>
    <v-client-table
      :data="table.items"
      :columns="table.columns"
      :options="table.options"
      class="table-default"
    >
      <template #h__full_name><div class="table-default__left">Name</div></template>
      <template #h__group><div class="table-default__left">Group</div></template>
      <template #full_name="{ row }">
        <div class="table-default__left table-default__left--photo">
          <span
            :class="`fflag ff-md fflag-${row.citizenship ? row.citizenship.code : 'empty'}`"
            v-tooltip="{ content: row.citizenship ? row.citizenship.name : 'Not provided', placement: 'top-start', offset: 10 }"
          ></span>
          <template v-if="row.gender">
            <img v-if="row.gender?.code || null === 'male'" src="@/assets/img/male-icon.svg" alt="">
            <img v-if="row.gender?.code || null === 'female'" src="@/assets/img/female-icon.svg" alt="">
          </template>
          <img v-else src="@/assets/img/gender-plug-icon.svg" alt="">
          <router-link
            :to="{ name: 'clients-detail', params: { id: row.id } }"
            class="table-default__link-border"
          >
            {{ row.full_name }}
          </router-link>
          <span v-if="row.age">({{ row.age }} y.o.)</span>
          <img v-if="row.category && row.category.code === 'tour_leader'" src="@/assets/img/tour-leader-icon.svg" alt="Leader">
          <img v-if="row.birthday" src="@/assets/img/birthday-icon.svg" alt="Birthday">
        </div>
      </template>
      <template #group="{ row }">
        <div class="table-default__left">
          <div class="table-default__controls" v-if="row.group && row.group.id">
            <router-link
              :to="{name: 'clients-groups-general', params: {id: row.group.id }}"
              class="table-default__link-border"
            >
              {{ row.group.name }}
            </router-link>
          </div>
          <span v-else>-</span>
        </div>
      </template>
      <template #created_by="{ row }">
        <div class="table-default__controls">
          <div class="table-default__photo">
            <img
              :src="getUserAvatar(row.created_by.crop.crop_url)"
              alt="Avatar"
              v-tooltip="{ content: row.created_by.full_name, placement: 'top-start', offset: 10 }"
            >
          </div>
        </div>
      </template>
      <template #controls="{ row }">
        <div class="table-default__controls">
          <button @click="onShowDeleteModal(row.id)" type="button">
            <img src="@/assets/img/delete-table-icon.svg" alt="Delete">
          </button>
        </div>
      </template>
    </v-client-table>
    <app-cells><h2 class="title">Hotels</h2></app-cells>
    <template v-if="reservations.length">
      <div v-for="(reservation, index) in reservations" :key="`reservations_${index}`">
        <AppAccHotel :reservation="reservation" :order-number="index + 1" />
      </div>
    </template>
    <div v-else class="no-results no-results--margin">
      <img src="@/assets/img/schedule-plug-icon.svg" alt="">
      <div class="no-results__title">No Results</div>
      <div class="no-results__text">There’s no reservations yet</div>
    </div>
    <modal
      name="delete-modal"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('delete-modal')" class="popup__close" type="button"></button>
        <div class="popup__title popup__title--flex">
          <img src="@/assets/img/warning-round-icon.svg" alt="">
          Delete client
        </div>
        <div class="popup__body">
          <div class="popup__subt">Are you sure you want to delete this client?</div>
          <app-cells position="center" :indent="false">
            <app-button @click.native="$modal.hide('delete-modal')" theme="dark">Cancel</app-button>
            <app-button @click.native="onDeleteClient" ref="delete">Yes</app-button>
          </app-cells>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { deleteIslandVacationGroupClient, getIslandVacationGroupClients, getReservationsHotelsList } from '@/http'
import AppAccHotel from '@/components/AppAccHotel.vue'

export default {
  name: 'IslandVacationGroupsDetailClients',
  components: { AppAccHotel },
  data() {
    return {
      table: {
        items: [],
        columns: ['full_name', 'group', 'created_by', 'controls'],
        options: {
          headings: {
            full_name: 'Name',
            date: 'Group',
            created_by: 'Manager',
            controls: '',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 100,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      item_to_delete: null,
      reservations: [],
    }
  },
  created() {
    this.fetchClients()
    getReservationsHotelsList({ island_group: this.$route.params.id, sales_status_exclude: 'cancel' })
      .then(res => {
        this.reservations = res.data
      })
  },
  methods: {
    fetchClients() {
      getIslandVacationGroupClients(this.$route.params.id)
        .then(response => {
          this.table.items = response.data
        })
    },
    onShowDeleteModal(id) {
      this.item_to_delete = id
      this.$modal.show('delete-modal')
    },
    onDeleteClient() {
      this.$refs.delete.preload = true
      deleteIslandVacationGroupClient(this.$route.params.id, this.item_to_delete)
        .then(() => {
          this.fetchClients()
          this.$modal.hide('delete-modal')
          this.$notify({
            type: 'success',
            title: 'Client deleted',
          })
        })
        .catch(() => {
          this.$refs.delete.preload = false
        })
    },
    getUserAvatar(crop_url) {
      if (crop_url) return crop_url
      return require('@/assets/img/temp/avatar-slug.jpg')
    },
  }
}
</script>
